import React from 'react';
import PropTypes from 'prop-types';
import TreeView from 'components/common/TreeView';
import Spin from 'components/common/Spin';
import Types from 'routes/General/Types';
import {connect} from 'react-redux';
import {indexRecruitmentTypes} from 'routes/Home/Basic/Personnel/Module';
import  {index} from "routes/Home/Basic/Category/Module"
import store from "store"
@connect((state) => ({
  types: state.Basic.Category.categories,
}), {
  indexTypes: indexRecruitmentTypes,
  index:index
})
@autobind
/**
 *
 * @class ListWrapper
 * @extends PureComponent
 */
export default class ListWrapper extends React.PureComponent {
  static propTypes = {
    selected: PropTypes.arrayOf(
      PropTypes.string,
    ),
    onCheck: PropTypes.func,
    title: PropTypes.any,
    checkAll: PropTypes.bool,
    types: PropTypes.arrayOf(PropTypes.object),
    indexTypes: PropTypes.func,
  };

  static defaultProps = {
    selected: [],
    onCheck: () => {
    },
    checkAll: true,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selected: props.selected,
      indexBardia:[]
    };
  }


  /**
   *
   */
  componentDidMount() {
    const {indexTypes} = this.props;
    // index((err,res)=>console.log("resdvsdv",res))
    store.dispatch(
      index({ page: 0, limit: 100 }, (res) => this.setState({loading: false}))
    );
    // indexTypes((err) => !err && this.setState({loading: false}));
  }

  /**
   *
   */
  componentDidUpdate() {
    const {indexTypes} = this.props;

    indexTypes((err,res) => console.log("resresresresres",res));
  }
  /**
   *
   * @return {Array}
   */
  selected() {
    return this.treeView.selected();
  }

  /**
   *
   * @param {Array} _selected
   * @private
   */
  _onCheck(_selected) {
    const {onCheck, types} = this.props;
    const rules = types;
    let selected = [];


    _selected.map((item) => {
      let _item = rules.find((_item) => _item.id === parseInt(item));
      if (_item && _item.rule) {
        selected.push(`${_item.title}`);
      }
    });

    this.setState({
      selected: _selected,
    });

    onCheck(_selected);
  }

  _renderItems(types, typeId) {
    let items = [];
    if (types && types[0]) {
      types.map((type) => {
        // console.log(types, typeId, type.typeId === typeId , !type.rule , type.rule && !type.rule.isPrivate );
        if ((!type.typeId && typeId === null) || ((type.typeId && type.typeId === typeId) && (!type.rule || !type.rule.isPrivate ))) {
          items.push({id: type.id, title: type.title, children: this._renderItems(type.children ? type.children : types,type.id)});
        }
      });
    }

    // console.log(items);
    return items;
  }

  /**
   *permissions
   * @return {Array}
   * @private
   */
  _renderData(types) {
    return this._renderItems(types, null);
  }

  get _selected() {
    const {selected} = this.state;
    const rules = this.props.types;
    let _selected = [];

    selected.map((item) => {
      let _item = rules.find((_item) => _item.rule && _item.rule.id === parseInt(item));
      if (_item) {
        _selected.push(`${_item.id}`);
      }
    });

    return selected;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {loading} = this.state;
    const {checkAll, title, types} = this.props;
    return (

      <div
        style={{
          height: 'calc(300px)',
          overflow: 'auto',
        }}
      >
        <Spin
          spinning={loading}
          style={{
            height: '100%',
          }}
        >
          <TreeView
            checkable
            title={title}
            showSearch={false}
            onCheck={this._onCheck}
            treeData={this._renderData(types)}
            defaultCheckedKeys={this._selected}
            checkAllButton={checkAll}
            treeStyle={{height: 'calc(100% - 44px)'}}
            ref={(input) => this.treeView = input}
          />
        </Spin>
      </div>
    );
  }
}
